/**
 * Login Page
 *
 * Public page for user login
 */

import { LoginForm } from '../../components/auth/LoginForm';

export function Login() {
  return <LoginForm />;
}
